import React, {Component} from "react"
import Layout from "../../../components/Layout"
import leng from "../../../data"

import "./index.scss"

import {
    DataTableSkeleton,
    Tabs, Tab,
    DataTable,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell, InlineNotification
} from "carbon-components-react";
import {
    mdata_action_canal,
    mdata_action_canal_nok,
    mdata_collections

} from "../../../store/actions/masterData";
import {connect} from "react-redux";
import moment from "moment";


const headerData2 = [
    {key: "urlPath", header: 'Path'},
    {key: "creationDate", header: 'Creation Date'},
    {key: "Error", header: 'Message'},
];
const headerData3 = [
    {key: "cnpj", header: 'CNPJ'},
    {key: "description", header: 'Description'},
    {key: "channel_siop", header: 'Channel SIOP'},
    {key: "urlPath", header: 'Path'},
];

class MasterData extends Component {
    state = {activeTab: 0, activeTabHead: 1};

    async componentDidMount() {
        await this.props.fetchData();
    }

    handleClick = (e, tab) => {
        e.preventDefault();
        console.log(tab);
        this.setState({
            activeTab: tab
        });

        if (tab === 0)
            this.props.fetchData();
        if (tab === 1)
            this.props.canalNOk();
    };

    render() {
        let {data, isLoading} = this.props;

        let rowData = data;
        rowData =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                    };
                })
                : [];
        if (rowData?.length > 0) rowData.sort((a, b) => b.sortDate - a.sortDate);
        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p>Dataset / {leng.sideBar.repositorio.title}</p>
                        <h1>{leng.sideBar.repositorio.links[1]}</h1>
                        <br/>
                    </div>
                    <div>
                        <Tabs  className="padding-tab-head" light={"false"} scrollIntoView={false} type='container'
                              class='space-title'
                              selected={this.state.activeTabHead}>
                            <Tab
                                className="head-dark"
                                light={"false"}
                                id="produto-head"
                                label="Product"
                                key={0}
                                onClick={e => {
                                    this.props.history.push('/repo/master-data');
                                }}
                            >
                            </Tab>
                            <Tab
                                className="head-dark"
                                light={"false"}
                                id="canal-head"
                                key={1}
                                label="Channel" onClick={e => {
                                this.handleClick(e, 0)
                            }}
                            >

                                <div className="section-light">
                                    <div className="section-light-heading-p0">
                                        <div className="file-upload-container">
                                            <div className="tabs-story-wrapper--light">

                                                <Tabs scrollIntoView={false} selected={this.state.activeTab}>
                                                    <Tab id="canal" key={0} label="Channel" onClick={e => {
                                                        this.handleClick(e, 0)
                                                    }}>
                                                        <div className="content-tab-canal">
                                                            {!isLoading && rowData.length == 0 ? (
                                                                <div>
                                                                    <InlineNotification
                                                                        lowContrast={true}
                                                                        kind="info"
                                                                        iconDescription="Info"
                                                                        subtitle={<span>No data found</span>}
                                                                        title=""
                                                                    />
                                                                </div>) :("")}
                                                            {isLoading ? (
                                                                <div className="bx--col-padding p-2-rem">
                                                                    <DataTableSkeleton/>
                                                                </div>
                                                            ) : (
                                                                <DataTable
                                                                    rows={rowData}
                                                                    headers={headerData3}>
                                                                    {({
                                                                          rows,
                                                                          headers,
                                                                          getHeaderProps,
                                                                          getRowProps,
                                                                          getTableProps
                                                                      }) => (
                                                                        <TableContainer title="Valid Data">
                                                                            <Table {...getTableProps()}>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        {headers.map(header => (
                                                                                            <TableHeader {...getHeaderProps({header})}>
                                                                                                {header.header}
                                                                                            </TableHeader>
                                                                                        ))}
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {rows.map((row) => (
                                                                                        <TableRow
                                                                                            className="upload-row"
                                                                                            key={row.id}
                                                                                            {...getRowProps({row})}
                                                                                        >
                                                                                            {row.cells.map((cell) => (
                                                                                                <TableCell
                                                                                                    key={cell.id}>
                                                                                                    {cell.value}
                                                                                                </TableCell>
                                                                                            ))}
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    )}
                                                                </DataTable>
                                                            )}
                                                        </div>
                                                    </Tab>

                                                    <Tab id="canalNOk" key={1} label="Channel NOK" onClick={e => {
                                                        this.handleClick(e, 1)
                                                    }}>
                                                        <div className="content-tab-canal">
                                                            {!isLoading && rowData.length == 0 ? (
                                                                <div>
                                                                    <InlineNotification
                                                                        lowContrast={true}
                                                                        kind="info"
                                                                        iconDescription="Info"
                                                                        subtitle={<span>No data found</span>}
                                                                        title=""
                                                                    />
                                                                </div>) :("")}
                                                            {isLoading ? (
                                                                <div className="bx--col-padding  p-2-rem">
                                                                    <DataTableSkeleton/>
                                                                </div>
                                                            ) : (
                                                                <DataTable
                                                                    rows={rowData}
                                                                    headers={headerData2}>
                                                                    {({
                                                                          rows,
                                                                          headers,
                                                                          getHeaderProps,
                                                                          getRowProps,
                                                                          getTableProps
                                                                      }) => (
                                                                        <TableContainer title="Discarded Data">
                                                                            <Table {...getTableProps()}>
                                                                                <TableHead>
                                                                                    <TableRow>
                                                                                        {headers.map(header => (
                                                                                            <TableHeader {...getHeaderProps({header})}>
                                                                                                {header.header}
                                                                                            </TableHeader>
                                                                                        ))}
                                                                                    </TableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {rows.map((row) => (
                                                                                        <TableRow
                                                                                            className="upload-row"
                                                                                            key={row.id}
                                                                                            {...getRowProps({row})}
                                                                                        >
                                                                                            {row.cells.map((cell) => (
                                                                                                <TableCell
                                                                                                    key={cell.id}>
                                                                                                    {cell.value}
                                                                                                </TableCell>
                                                                                            ))}
                                                                                        </TableRow>
                                                                                    ))}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    )}
                                                                </DataTable>
                                                            )}
                                                        </div>
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </Tab>
                            <Tab
                                className="head-dark"
                                light={"false"}
                                id="planejamento-head"
                                key={2}
                                label="Planning"
                                onClick={e => {
                                    this.props.history.push('/repo/master-data/planejamento');
                                }}>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </Layout>
        )
    }
}


const mapStateToProps = ({mdata}) => mdata;

const mapDispatchToProps = dispatch => ({
    canalNOk: () => dispatch(mdata_collections()),
    fetchData: () => dispatch(mdata_collections()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MasterData);
